import {Navigate, NonIndexRouteObject, RouteObject} from 'react-router';

interface Config {
  loginRoute?: Omit<NonIndexRouteObject, 'path'>;
  registerRoute?: Omit<NonIndexRouteObject, 'path'>;
  accountSettingsRoute?: Omit<NonIndexRouteObject, 'path'>;
}

export function authRoutes({
  loginRoute,
  registerRoute,
  accountSettingsRoute,
}: Config = {}): RouteObject[] {
  return [
    {
      path: '/register',
      ...(loginRoute ? loginRoute : defaultLoginRoute),
    },
    {
      path: '/login',
      ...(loginRoute ? loginRoute : defaultLoginRoute),
    },
    {
      path: '/workspace/join/register',
      ...(loginRoute ? loginRoute : defaultLoginRoute),
    },
    {
      path: '/workspace/join/login',
      ...(loginRoute ? loginRoute : defaultLoginRoute),
    },
    {
      path: '/forgot-password',
      element: <Navigate to="/login" replace />,
    },
    {
      path: '/password/reset/:token',
      element: <Navigate to="/login" replace />,
    },
    {
      path: '/account-settings',
      ...(accountSettingsRoute
        ? accountSettingsRoute
        : defaultAccountSettingsRoute),
    },
  ];
}

const defaultLoginRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {LoginPageWrapper: Component} = await import(
      '@common/auth/ui/login-page-wrapper'
    );
    return {Component};
  },
};

const defaultRegisterRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {RegisterPage: Component} = await import(
      '@common/auth/ui/register-page'
    );
    return {Component};
  },
};

const defaultAccountSettingsRoute: NonIndexRouteObject = {
  lazy: async () => {
    const {AccountSettingsPage: Component} = await import(
      '@common/auth/ui/account-settings/account-settings-page'
    );
    return {Component};
  },
};
